export default __webpack_public_path__ + "static/media/pending.d8653dca.svg";